import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=17e490ca&scoped=true&"
import script from "./Welcome.vue?vue&type=script&lang=js&"
export * from "./Welcome.vue?vue&type=script&lang=js&"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=17e490ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_babel-core@7.0.0-bridge.0_@babel+core@7.12.10__css-loader@5.0.1_webpa_2f9c74bd8b0234781e6cf928f27b0315/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e490ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17e490ca')) {
      api.createRecord('17e490ca', component.options)
    } else {
      api.reload('17e490ca', component.options)
    }
    module.hot.accept("./Welcome.vue?vue&type=template&id=17e490ca&scoped=true&", function () {
      api.rerender('17e490ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/pages/welcome/Welcome.vue"
export default component.exports